<template>
<div>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="user_official_factor_filter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('reports.users.select_date_interval') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#user_official_factor_filter">
                    <div class="card-body">
                        <form id="unofficial_factor_form" @submit.prevent="search($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('reports.gateways.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    class=" btn btn-label-danger trash-btn"
                                                    type="button"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                id="from_date"
                                                name="from_date"
                                                v-model="query.from_date"
                                                type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('reports.gateways.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    class=" btn btn-label-danger trash-btn"
                                                    type="button"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                format="YYYY-MM-DD"
                                                display-format="dddd jDD jMMMM jYYYY"
                                                input-class="form-control"
                                                id="to_date"
                                                name="to_date"
                                                v-model="query.to_date"
                                                type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="user_id">
                                                {{ $t('label.user_id') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                id="user_id"
                                                class="form-control"
                                                name="user_id"
                                                v-model="query.user_id"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="wallet_id">
                                                {{ $t('label.wallet_id') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                id="wallet_id"
                                                class="form-control"
                                                name="wallet_id"
                                                v-model="query.wallet_id"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <kt-row>
                                    <kt-col xs="12" sm="6" md="6"></kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <button
                                            class="btn btn-success btn-wide float-right"
                                            type="button"
                                            id="export_btn"
                                            @click="actionAllUsers($event, query)"
                                        >
                                            {{ $t('reports.btn.all_users_factors') }}
                                        </button>
                                        <button
                                            class="btn btn-success btn-wide float-right mr-3"
                                            type="button"
                                            id="search_btn"
                                            @click="search($event, query)"
                                        >
                                            {{ $t('label.search') }}
                                        </button>
                                    </kt-col>
                                </kt-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>

    <div class="fh-datatable bg-white">
        <table v-if="excelRequests.data && excelRequests.data.length > 0" class="table table-light-bordered">
            <thead>
                <tr style="font-size: 0.89rem;">
                    <td style="text-align: center; width:70px">#</td>
                    <td style="text-align: center">{{ $t('label.from_date') }}</td>
                    <td style="text-align: center">{{ $t('label.to_date') }}</td>
                    <td style="text-align: center">{{ $t('label.status') }}</td>
                    <td style="text-align: center">عملیات</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(req, index) in excelRequests.data" :key="index">
                    <td style="text-align: center">{{ req.id }}</td>
                    <td style="text-align: center">{{ req.from_date }}</td>
                    <td style="text-align: center">{{ req.to_date }}</td>
                    <td style="text-align: center">
                        <div class="text-white" :class="excelStatusVariant(req.status)">
                            {{ excelStatusStr(req.status) }}
                        </div>
                    </td>
                    <td class="text-center d-flex justify-content-center align-items-center">
                        <a v-show="req.url" :href="req.url" type="button"
                            style="background: none; border: none; color: #7878e4">
                            <i class="fa fa-download"></i>
                        </a>
                        <button @click="handleDelete(req.id)"
                            style="background: none; border: none; color: #c90000">
                            <i class="fa fa-trash"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <div v-if="excelRequests.data && excelRequests.data.length > 0" class="pager kt-datatable--paging-loaded">
            <div class="paginationR">
                <button class="btn-link" title="اولی" @click="changePage(1)">&laquo;&laquo;</button>
                <button class="btn-link" title="قبلی" @click="changePage(excelRequests.current_page - 1)">&laquo;</button>
                <span v-for="page in pageRange" :key="page">
                    <button
                        @click="changePage(page)"
                        :class="{ 'active': excelRequests.current_page == page }">
                        {{ page }}
                    </button>
                </span>
                <button class="btn-link" title="بعدی" @click="changePage(excelRequests.current_page + 1)">&raquo;</button>
                <button class="btn-link" title="آخری" @click="changePage(excelRequests.last_page)">&raquo;&raquo;</button>
            </div>
            <div class="pager-info">
                <select class="mr-3 ml-3 kt-datatable__pager-size" style="width: 60px;" title="اندازه صفحه"
                    @change="changePage(1)" id="perpage-value" v-model="per_page">
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                </select>
                <span class="kt-datatable__pager-detail">
                    {{ 'نمایش ' + excelRequests.from + ' - ' + excelRequests.to + ' از ' + excelRequests.total }}
                </span>
            </div>
        </div>

        <div v-else class="text-center p-5 my-3">
            درخواست خروجی اکسل برای شما وجود ندارد!
        </div>
    </div>
</div>
</template>

<script>
import $ from "jquery";
import { i18n } from '@/plugins/i18n'
import { KTApp } from "@/plugins/core/app";
import { ApiService } from "@/common/api.service";
import toastr from "toastr";

export default {
    data() {
        return {
            query: {},
            per_page: 10,
            page: 1,
            excelRequests: {
                data: [],
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0,
                total: 0,
            },
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
        pageRange() {
            const start = Math.max(1, this.excelRequests.current_page - 2)
            const end = Math.min(this.excelRequests.last_page, this.excelRequests.current_page + 2)
            const pages = []
            for (let i = start; i <= end; i++) pages.push(i)
            return pages
        },
    },
    methods: {
        clearFromDate() {
            this.query.from_date = null
        },
        clearToDate() {
            this.query.to_date = null
        },
        excelStatusVariant(status) {
            if (status === 'CREATED') return 'badge badge-secondary'
            if (status === 'PROCESSING') return 'badge badge-warning'
            if (status === 'PROCESSED') return 'badge badge-success'
        },
        excelStatusStr(status) {
            if (status === 'CREATED') return i18n.t('transaction.excelStatus.created')
            if (status === 'PROCESSING') return i18n.t('transaction.excelStatus.processing')
            if (status === 'PROCESSED') return i18n.t('transaction.excelStatus.processed')
        },
        changePage(page) {
            if (page < 1 || page > this.excelRequests.last_page) return
            this.page = page
            this.fetchExcelFiles()
        },
        search(_event, query) {
            let btn = $('#search_btn')
            KTApp.progress(btn)
            ApiService.post('reports/admin/get-user-unofficial-factor', query)
                .then(() => {
                    this.toastr.success(i18n.t('reports.users.request_sent'))
                    this.page = 1
                    this.fetchExcelFiles()
                }).catch(({ response }) => {
                    if (response && response.data && response.data.message) {
                        this.toastr.error(response.data.message)
                    }
                }).finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        actionAllUsers(_event, query) {
            let btn = $('#export_btn')
            KTApp.progress(btn)
            let payload = { ...query }
            delete payload.user_id
            ApiService.post('reports/admin/get-user-unofficial-factor', payload)
                .then(() => {
                    this.toastr.success(i18n.t('reports.users.request_sent'))
                    this.page = 1
                    this.fetchExcelFiles()
                }).catch(({ response }) => {
                    if (response && response.data && response.data.message) {
                        this.toastr.error(response.data.message)
                    }
                }).finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        handleDelete(hashid) {
            ApiService.delete('reports/admin/unofficial-factor-excel', hashid)
                .then(({ data }) => {
                    this.toastr.success(data.message)
                    this.fetchExcelFiles()
                }).catch(({ response }) => {
                    if (response && response.data && response.data.message) {
                        this.toastr.error(response.data.message)
                    }
                })
        },
        fetchExcelFiles() {
            ApiService.query('reports/admin/get-user-export-excels-unofficial-factor', {
                params: { page: this.page, per_page: this.per_page }
            }).then(({ data }) => {
                this.excelRequests = data.data
            })
        },
    },
    mounted() {
        this.fetchExcelFiles()
    },
}
</script>

<style></style>
